import React, { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import SimpleSlider from "./SliderCustom";
// import SimpleSlider from "./SimpleSlider";
import styled, { css } from "styled-components";
import AudioPlay from "./AudioPlay";
import { useAudios } from "../hooks/useAudios";
import { useImages } from "../hooks/useImages";
import { useModeContinuous } from "../hooks/useModeContinuous";

const LessonDataBox = ({ seed, freeze = false, onChange = () => {}}) => {
  const extractedImages = useMemo(() => seed.map((i) => i.image), [seed]);
  const extractedAudios = useMemo(() => seed.map((i) => i.audio), [seed]);

 const { isModeContinuous } = useModeContinuous();
 const [isCurrentAudioEnded, setIsCurrentAudioEnded] = useState(false);

  const sliderRef = useRef(null);

  const images = useImages(extractedImages);
  const audios = useAudios(extractedAudios);

  const isLoaded = ({ image, audio }) =>
    ((image && images[image]) || !image) &&
    ((audio && audios[audio]) || !audio);

  const [currentIndex, setCurrentIndex] = useState(0);

  useLayoutEffect(() => {
    setIsCurrentAudioEnded(false);
  }, [currentIndex]);

  useEffect(() => {
    if (isCurrentAudioEnded && isModeContinuous) {
      const id = setTimeout(() => {
        sliderRef.current?.goToNextSlide?.();
      }, 2000);
      return () => {
        clearTimeout(id);
      };
    }
  }, [isCurrentAudioEnded, isModeContinuous]);

  const handleOnEndCurrentCard = useCallback(() => {
    setIsCurrentAudioEnded(true);
  }, []);

  return (
    <Container>
      <SimpleSlider
        length={seed.length}
        ref={sliderRef}
        onLastChild={() => {
          onChange({ ready: true, data: seed });
        }}
        onChangeIndex={setCurrentIndex}
      >
        {seed.map((item, index) => (
          <BoxWrapper key={index}>
            {isLoaded(item) ? (
              <Box freeze={freeze}>
                {item.image && <Image src={images[item.image]} />}
                {(item.text || item.audio) && (
                  <Row>
                    {item.text && <Text>{item.text}</Text>}
                    {item.audio && (
                      <AudioPlay
                        audio={audios[item.audio]}
                        isAutoplay={index === currentIndex}
                        onEnd={handleOnEndCurrentCard}
                      />
                    )}
                  </Row>
                )}
              </Box>
            ) : (
              <Spinner src="loading-blue.gif" />
            )}
          </BoxWrapper>
        ))}
      </SimpleSlider>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
`;

const BoxWrapper = styled.div``; // NECESSARY

const Box = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 20px;
  overflow: hidden;
  width: 95%;
  margin: 0 auto;

  ${(props) =>
    props.freeze &&
    css`
      pointer-events: none;
    `}
`;

const Image = styled.img`
  width: 100%;
  max-height: 360px;
  object-fit: contain;
`;

const Row = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  padding: 10px 10px;
  & > * {
    margin: 5px;
  }
`;

const Text = styled.div`
  font-size: 0.9em;
  color: black;
`;

const Spinner = styled.img`
  margin: auto;
  width: 25px;
  height: 25px;
  display: block;
`;

export default LessonDataBox;

// <Container>
//   <SimpleSlider
//     length={seed.length}
//     onLastChild={() => {
//       onChange({ ready: true, data: seed });
//     }}
//   >
//     {seed.map((item, index) => (
//       <BoxWrapper key={index}>
//         {isLoaded(item) ? (
//           <Box freeze={freeze}>
//             {item.image && <Image src={images[item.image]} />}
//             {(item.text || item.audio) && (
//               <Row>
//                 {item.text && <Text>{item.text}</Text>}
//                 {item.audio && <AudioPlay audio={audios[item.audio]} />}
//               </Row>
//             )}
//           </Box>
//         ) : (
//           <Spinner src="loading-blue.gif" />
//         )}
//       </BoxWrapper>
//     ))}
//   </SimpleSlider>
// </Container>
